export const name = 'detectAutoFill';

export default function detectAutoFill($timeout) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var directive = {
    require: 'ngModel',
    restrict: 'EA',
    link: detectAutoFillLink,
  };

  return directive;

  //////////////////////
  function detectAutoFillLink(scope, element, attrs, ctrl) {
    let focusId = attrs.focusCtrl;
    let start = element.val();
    $timeout(() => {
      let current = element.val();
      if (ctrl.$pristine && start !== current) {
        ctrl.$setViewValue(current);
        let focusCtrl = document.getElementById(focusId);
        if (focusCtrl) {
          focusCtrl.focus();
        }
      }
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./components/sign-in/detectAutoFill.directive.js